import { PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Button } from 'antd';
import { useOpenDrawerHandler } from 'hooks';
import { Drawers } from 'app/types/drawer';
import { Can } from 'components';
import { User } from 'constants/index';
import { Worker } from 'app/types/worker';

const NewDocument = ({ worker }: { worker: Worker }) => {
  const { t } = useTranslation();

  const handleClick = useOpenDrawerHandler({ key: Drawers.ADD_WORKER_DOCUMENT, props: { worker } });

  return (
    <Can requiredPermission={User.Permissions.MANAGE_WORKER_DOCUMENTS}>
      <Button onClick={handleClick} icon={<PlusOutlined />} type='link'>
        {t('common.addnew')}
      </Button>
    </Can>
  );
};

export default NewDocument;
